import { useEffect } from 'react';
import { v4 as uuid } from 'uuid';
import type { IFramework } from '../../framework';

export function useSelectAllHotkey(framework: IFramework) {
    const { edgelessCanvas, frame: frameOperate } = framework.service;

    useEffect(() => {
        const handle = framework.service.hotkey.onSelectAll(() => {
            let originIndex = framework.service.frame.getActiveFrameId();

            if (edgelessCanvas.isEdgelessMode) {
                originIndex = frameOperate.getHoverFrameId() ?? frameOperate.getFrameSelectionFrameId() ?? originIndex;
            }

            frameOperate.delActiveLayer();

            const layers = frameOperate.getCollisionLayers(originIndex);
            if (layers.length === 0) return;
            if (layers.length === 1) {
                frameOperate.setActiveLayer(layers[0].id);
                frameOperate.delHoverId();
                return;
            }

            const pickIdsSet = new Set(layers.map((item) => item.id));
            const groupLayer = frameOperate.tryCreateGroup(originIndex, uuid(), pickIdsSet);
            if (!groupLayer) return;

            frameOperate.addOrUpdateLayer(groupLayer, originIndex, true);
            frameOperate.setActiveLayer(groupLayer.id);
            frameOperate.delHoverId();
        });

        return () => {
            framework.service.events.off(handle);
        };
    }, []);
}
